import { FormattedMessage } from 'dibs-react-intl';
import styles from './BackButton.scss';
export const BackButton = props => (
    <div className={styles.backLink}>
        <a onClick={props.onClick} data-tn="back-button">
            <span className={styles.backLinkText}>
                <FormattedMessage id="abt.matchmaker.backButton" defaultMessage="Back" />
            </span>
        </a>
    </div>
);
